import styled from '@emotion/styled';

export const PrivacyComponentStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: '100vh',
  '.iframe': {
    height: '100%',
    width: '100%'
  }
});
